export const toggle = (element) => {
    if (element.style) {
        if (element.style.display === 'none') {
            element.style.display = 'block';
        } else {
            element.style.display = 'none';
        }
    }
};

export const show = (element) => {
    if (element.style) {
        element.style.display = 'block';
    }
};

export const hide = (element) => {
    if (element.style) {
        element.style.display = 'none';
    }
};

export const visible = (element) => {
    if (element.style) {
        element.style.visibility = 'visible';
    }
};

export const hidden = (element) => {
    if (element.style) {
        element.style.visibility = 'hidden';
    }
};

/**
 * @param {JQuery<HTMLElement>} $target 이벤트를 붙일 대상
 * @param {
 * "click",  "change", "select", "submit", "scroll",
 * "mousedown", "mouseup", "mousemove", "mouseover", "mouseout", "mouseenter", "mouseleave",
 * "blur", "focus", "load", "resize", "unload", "beforeunload",  "keydown", "keypress", "keyup"
 * } action DOM 액션명
 * @param {string} actionName 매핑시킬 액션 함수명
 */
export const addActionEventAttribute = ($target, action, actionName) => {
    $target.attr(`data-action-${action}`, actionName);
};

/**
 * @param {JQuery<HTMLElement>} container 탐색이 종료될 최상위 대상
 * @param {JQuery<HTMLElement>} $target 탐색을 시작할 대상
 * @param {string} data 찾을 데이터 속성
 * @returns {jQuery|HTMLElement|JQuery<HTMLElement>} 해당 데이터 속성을 보유한 jQuery 엘리먼트
 */
export const getDataTarget = (container, $target, data) => {
    let actionTarget = jQuery($target);

    while (actionTarget.exists() && !actionTarget.is(container) && !actionTarget.data(data)) {
        actionTarget = actionTarget.parent();
    }

    return actionTarget;
};

/**
 * @param {JQuery<HTMLElement>} $root 이벤트를 listen할 최상단 엘리먼트
 * @param {
 * "click",  "change", "select", "submit", "scroll",
 * "mousedown", "mouseup", "mousemove", "mouseover", "mouseout", "mouseenter", "mouseleave",
 * "blur", "focus", "load", "resize", "unload", "beforeunload",  "keydown", "keypress", "keyup"
 * } action DOM 액션명
 * @param {{[key: string]: ($target: jQuery<HTMLElement>, e: Event) => void}} actions key: 매핑시킬 함수명, value: 실행할 내용
 */
export const listenActionEvent = ($root, action, actions) => {
    $root.on(action, (e) => {
        const $target = getDataTarget($root, e.target, `action-${action}`);
        const actionName = $target.data(`action-${action}`);

        if (actionName in actions) {
            actions[actionName]($target, e);
        }
    });
};

/**
 * @param {JQuery<HTMLElement>} $parent 대상 children을 랜덤으로 섞어 준다.
 * @returns {JQuery<HTMLElement>} $parent
 */
export const shuffleItems = ($parent) => {
    const $divs = $parent.children();
    while ($divs.length) {
        $parent.append($divs.splice(Math.floor(Math.random() * $divs.length), 1)[0]);
    }
    return $parent;
};
